import { initialState } from '../PlaceInitialState';

const reset = (state, payload) => {
  return initialState;
};

export { reset };
